var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"icon-button","href":_vm.url,"target":_vm.openInNewTab ? '_blank' : ''}},[_c('img',{attrs:{"src":_vm.ic,"alt":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }